import {Dialog, Typography, Box} from '@mui/material'
import styled from 'styled-components'
import theme from '../../styles/theme'
import CloseIcon from '@mui/icons-material/Close'

export const StyledDialog = styled(Dialog)`
  margin-bottom: 40px;

  && .MuiDialog-paper {
    border-radius: 5px;
  }
`

export const StyledCloseIcon = styled(CloseIcon)`
  position: absolute;
  top: 8px;
  right: 8px;
`

export const DialogTitle = styled(Typography)`
  font-size: 32px !important;
  color: #2d2d2d !important;
  justify-content: space-between;
  font-family: Freight Disp Pro !important;
  text-align: center !important;

  ${theme.breakpoints.down('sm')} {
    font-size: 24px !important;
  }
`
export const DialogBox = styled(Box)`
  padding: 40px 32px;
  width: 620px;
  overflow-x: hidden;
  box-sizing: border-box;

  ${theme.breakpoints.down('sm')} {
    width: 100%;
  }

  ${theme.breakpoints.down('xs')} {
    width: auto;
    padding: 24px 20px 20px 20px;
  }
`

export const DialogSubtitle = styled(Typography)`
  font-size: 14px !important;
  color: #2d2d2d;
  margin-top: 40px !important;
`

export const DialogText = styled(Typography)`
  font-size: 16px !important;
  color: #2d2d2d !important;
  width: fit-content;
  align-items: center;
  margin-top: 20px !important;

  ${theme.breakpoints.down('sm')} {
    font-size: 14px !important;
  }
`

export const ButtonBox = styled(Box)<{$isCentered?: boolean}>`
  display: flex;
  margin-top: 40px;
  width: 100%;
  justify-content: space-between;

  ${({$isCentered}) =>
    $isCentered
      ? `
      justify-content: center;
    `
      : `justify-content: space-between;`}

  && button {
    width: 250px !important;
    height: 55px !important;
  }

  ${theme.breakpoints.down('sm')} {
    flex-flow: column;
    gap: 24px;

    && button {
      width: 100% !important;
    }
  }
`

export const SelectionBox = styled(Box)`
  display: flex;
  margin-top: 10px;
  width: 100%;
  justify-content: space-evenly;
  margin-top: 24px;

  ${theme.breakpoints.down('sm')} {
    flex-flow: column;
    justify-content: center;
    align-items: center;
    gap: 24px;
  }
`

export const Selection = styled(Box)<{$isActive?: boolean}>`
  border-radius: 5px;
  padding: 20px;
  width: 250px;
  height: 152px;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-sizing: border-box;

  ${({$isActive}) =>
    $isActive
      ? `
      border: 2px solid #1377D4;
      background-color: #e8f3fd;
    `
      : `
      border: 2px solid #979797;
    `}

  &:hover {
    border: 2px solid #1377d4;
    background-color: #e8f3fd;
  }

  ${theme.breakpoints.down('sm')} {
    width: 100%;
    height: auto;
  }
`

export const SelectionTitle = styled(Typography)`
  font-size: 16px !important;
  font-weight: bold !important;
  color: #2d2d2d !important;
`

export const SelectionText = styled(Typography)`
  font-size: 12px !important;
  color: #2d2d2d !important;
`
